/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateUserAvailableDto {
  isCreateUserAvailable: boolean;
}

export interface DefaultPrinterConfigurationDto {
  /** @format uuid */
  printerId: string;
  printerType: PrinterTypeDto;
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface PrinterProjectionDto {
  displayName: string;
  name: string;
  /** @format uuid */
  printerId: string;
  type: PrinterTypeDto;
}

export enum PrinterTypeDto {
  DOCUMENT = "DOCUMENT",
  ZEBRA = "ZEBRA",
  VLOG = "VLOG",
}

/** @example "MS" */
export enum SalutationTypeDto {
  MR = "MR",
  MS = "MS",
  DIVERSE = "DIVERSE",
}

export interface UserConfigurationDto {
  /** @uniqueItems true */
  defaultPrinters: DefaultPrinterConfigurationDto[];
}

export interface UserDetailDto {
  /**
   * Active status of user
   * @example true
   */
  active: boolean;
  /**
   * Email address
   * @format email
   * @minLength 1
   * @example "mail@example.com"
   */
  email: string;
  /**
   * First name
   * @minLength 2
   * @maxLength 64
   * @example "Maxima"
   */
  firstname: string;
  group: UserGroupTypeDto;
  /** Id managed by keycloak */
  keycloakId?: string;
  /**
   * Last name
   * @minLength 2
   * @maxLength 64
   * @example "Muster"
   */
  lastname: string;
  /**
   * Phone number
   * @minLength 1
   * @example "+490162123456"
   */
  phoneNumber: string;
  /** Remark */
  remark?: string;
  salutation?: SalutationTypeDto;
  /** username - not configurable */
  username?: string;
  /**
   * Current version of the resource. Must be set to the version of the read operation.
   * @format int64
   */
  version?: number;
}

/** @example "CLERK" */
export enum UserGroupTypeDto {
  UNAUTHORIZED = "UNAUTHORIZED",
  ADMIN = "ADMIN",
  CLERK = "CLERK",
  SUPPORT = "SUPPORT",
  THIRD_LEVEL_SUPPORT = "THIRD_LEVEL_SUPPORT",
  ACCOUNTING = "ACCOUNTING",
  VIEWER = "VIEWER",
}

export interface UserListDto {
  items: UserListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface UserListItemDto {
  active?: boolean;
  email: string;
  firstname: string;
  group: UserGroupTypeDto;
  /** @format uuid */
  id: string;
  lastname: string;
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title User management service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Ums<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Printer Projection
     * @name FindPrinters
     * @summary Find first 50 printers
     * @request GET:/api/v1/projection/printer
     * @secure
     */
    findPrinters: (params: RequestParams = {}) =>
      this.request<PrinterProjectionDto[], any>({
        path: `/api/v1/projection/printer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ListUsers
     * @summary Returns a list of users
     * @request GET:/api/v1/user
     * @secure
     */
    listUsers: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserListDto, any>({
        path: `/api/v1/user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CreateUser
     * @summary Creates a new user
     * @request POST:/api/v1/user
     * @secure
     */
    createUser: (data: UserDetailDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetConfiguration
     * @summary Gets configuration of current user
     * @request GET:/api/v1/user/configuration
     * @secure
     */
    getConfiguration: (params: RequestParams = {}) =>
      this.request<UserConfigurationDto, any>({
        path: `/api/v1/user/configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateConfiguration
     * @summary Update configuration of current user
     * @request PUT:/api/v1/user/configuration
     * @secure
     */
    updateConfiguration: (data: UserConfigurationDto, params: RequestParams = {}) =>
      this.request<UserConfigurationDto, any>({
        path: `/api/v1/user/configuration`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ValidateConfiguration
     * @summary Validate user configuration
     * @request POST:/api/v1/user/configuration/validation
     * @secure
     */
    validateConfiguration: (data: UserConfigurationDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/user/configuration/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CreateUserAvailable
     * @summary Checks whether creating a new user is possible
     * @request GET:/api/v1/user/create-available
     * @secure
     */
    createUserAvailable: (params: RequestParams = {}) =>
      this.request<CreateUserAvailableDto, any>({
        path: `/api/v1/user/create-available`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ValidateUser
     * @summary Validates a user
     * @request POST:/api/v1/user/validation
     * @secure
     */
    validateUser: (
      data: UserDetailDto,
      query?: {
        validateEmail?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/user/validation`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUser
     * @summary Gets a user by id
     * @request GET:/api/v1/user/{id}
     * @secure
     */
    getUser: (id: string, params: RequestParams = {}) =>
      this.request<UserDetailDto, any>({
        path: `/api/v1/user/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateUser
     * @summary Update a user
     * @request PUT:/api/v1/user/{id}
     * @secure
     */
    updateUser: (id: string, data: UserDetailDto, params: RequestParams = {}) =>
      this.request<UserDetailDto, any>({
        path: `/api/v1/user/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
